import { FC, useEffect, useRef, useState } from "react";

import { AreaRepository } from "core/data/index";

import { IArea, IAreaCAP } from "core/interfaces/data/IAreaRequest";
import IAreaProps from "pages/Prenotazione/Form/Area/IAreaProps";

import { Form, Input, Button, List, ConfigProvider } from "antd";
import { CustomButton } from "core/interfaces/components/index";

import "./AreaCAP.css";
import { setArea } from "core/redux/features/dataForm/dataFormSlice";
import { performAsyncFunction } from "utils/AsyncFunctionUtility";
import { CustomButtonType } from "components/CustomButton/CustomButtonType";
import NavigationManager from "utils/NavigationManager";
import { FaSearch, FaTimesCircle } from "react-icons/fa";
import { modalListHeight } from "utils/Styles";
import { Enhanced } from "utils/ReactUtils";
import CustomTranslation from "components/CustomTranslation/CustomTranslation";
import CustomShelf from "components/CustomShelf/CustomShelf";

const AreaCAP: FC<IAreaProps> = ({ dispatch, sessionInfo, t, handleError, dataForm }) => {
	const { MoveStep } = NavigationManager(sessionInfo);

	const chooseAreaRef: any = useRef(); // aggiunta $ALC
	const startRef: any = useRef(); // aggiunta $ALC
	const mainInputRef: any = useRef(); // aggiunta $ALC

	const [loading, setLoading] = useState<boolean>(true);

	const [areeCAP, setAreeCAP] = useState<IAreaCAP[] | undefined>(undefined);
	const [areaCAPSelected, setAreaCAPSelected] = useState<IAreaCAP | undefined>(undefined);
	const [areaCAPFilter, setAreaCAPFilter] = useState<string>();

	const SetArea = (area: IArea) => {
		dispatch(setArea(area));
		MoveStep("next");
	};

	const [shelfOpen, setShelfOpen] = useState<boolean>(false); // aggiunta $ALC

	const onClickArea = () => {
		setShelfOpen(true); // aggiunta $ALC

		chooseAreaRef.current.focus();
		document.body.classList.add("noscroll");
	};
	const onPressEnterArea = (ev: any, area: IAreaCAP) => {
		// aggiunta $ALC
		ev.preventDefault();
		if (areeCAP !== undefined && areeCAP.length > 0) {
			setAreaCAPSelected(area);
			resetAreaCAPModal();
		}
	};
	const onClickModalClose = () => {
		resetAreaCAPModal();
	};

	const selectAreaCAP = (area: IAreaCAP) => {
		setAreaCAPSelected(area);
		resetAreaCAPModal();
	};
	const selectAreaCapPressEnter = (ev: any) => {
		// aggiunta $ALC
		ev.preventDefault();
		if (areeCAP !== undefined && areeCAP.length > 0) {
			console.log(areeCAP[0]);
			setAreaCAPSelected(areeCAP[0] as IAreaCAP);
			resetAreaCAPModal();
		}
	};

	const onAreaSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		var val = e.currentTarget.value;
		fetchAreeCAP(val);
		setAreaCAPFilter(val);
	};

	const resetAreaCAPModal = () => {
		setShelfOpen(false); // aggiunta $ALC

		document.body.classList.remove("noscroll");
		setAreaCAPFilter("");
		fetchAreeCAP("");
		mainInputRef.current.focus(); // aggiunta $ALC
	};

	const fetchAreeCAP = (filtro: string | undefined) => {
		performAsyncFunction(async () => {
			setLoading(true);
			const data = await AreaRepository.getAreeAssistenza(filtro);

			setAreeCAP(data);
			setLoading(false);
		}, handleError);
	};

	const OnSubmit = () => {
		let area: IArea = {
			CodGruppo: areaCAPSelected?.CodGruppo!,
			Descrzione: "",
			IdEquipe: areaCAPSelected?.IdEquipe!,
			LuogoErogazione: {
				CAP: areaCAPSelected?.CAP!,
				CodIstat: areaCAPSelected?.CodIstat!,
				Comune: areaCAPSelected?.Comune!,
				Provincia: areaCAPSelected?.Provincia!,
				Via: undefined,
				Civico: undefined,
				CAPMultipli: areaCAPSelected?.CAPMultipli,
			},
		};
		SetArea(area);
	};

	useEffect(() => {
		// aggiunta $ALC
		if (startRef.current) startRef.current.focus();
	}, []);

	useEffect(() => {
		performAsyncFunction(async () => {
			setLoading(true);
			const data = await AreaRepository.getAreeAssistenza(undefined);

			setAreeCAP(data);
			setLoading(false);
		}, handleError);

		if (dataForm.area) {
			let areaForm: IAreaCAP = {
				CodGruppo: dataForm.area.CodGruppo,
				IdEquipe: dataForm.area.IdEquipe,
				CAP: dataForm.area.LuogoErogazione!.CAP,
				CodIstat: dataForm.area.LuogoErogazione!.CodIstat!,
				Comune: dataForm.area.LuogoErogazione!.Comune,
				Provincia: dataForm.area.LuogoErogazione!.Provincia,
				CAPMultipli: dataForm.area.LuogoErogazione!.CAPMultipli!,
			};
			setAreaCAPSelected(areaForm);
		}
	}, [sessionInfo.step, dataForm.area, handleError, sessionInfo.sessione]);

	return (
		<div id="areaCAP" role="main" aria-label="Step 2">
			{/* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */}
			<div className="title item " tabIndex={0} ref={startRef}>
				<span>{t("areaCAP.titolo")}</span>
			</div>
			<div className="text item">
				<span>{t("areaCAP.sottotitolo")}</span>
			</div>
			<>
				<Form onFinish={OnSubmit}>
					<div className="area-cap-find">
						<div className="input-area-cap">
							<Input
								ref={mainInputRef}
								aria-label={t("scegliArea")}
								size="large"
								readOnly={true}
								type="text"
								onClick={onClickArea}
								onPressEnter={onClickArea}
								value={
									areaCAPSelected
										? `${areaCAPSelected.Comune} ${areaCAPSelected.CAPMultipli ? `cap ${areaCAPSelected.CAP} ` : ``}(${areaCAPSelected.Provincia})`
										: undefined
								}
								suffix={
									<Button className="svuota-input" aria-label={t("resetArea")} onClick={() => setAreaCAPSelected(undefined)}>
										<FaTimesCircle />
									</Button>
								}
							/>
						</div>
					</div>

					<CustomShelf open={shelfOpen} onClose={onClickModalClose} ariaLabel={t("scegliArea")}>
						<div className="div-modal-area-cap-input">
							<Input
								ref={chooseAreaRef}
								size="large"
								type="text"
								placeholder={t("areaCAP.filtroPlaceholder")}
								value={areaCAPFilter}
								onChange={onAreaSearchChange}
								onPressEnter={selectAreaCapPressEnter}
								suffix={<FaSearch />}
							/>
						</div>
						<div className="modal-scrollable-div" id="modal-scrollable-div" style={{ height: modalListHeight() }}>
							<ConfigProvider renderEmpty={() => <></>}>
								<List
									size="large"
									bordered
									rowKey={(area) => `${area.CodIstat}_${area.CAP}_${area.IdEquipe}_${area.CodGruppo}`}
									loading={loading}
									dataSource={areeCAP}
									renderItem={(area) => (
										<List.Item
											className="modal-area-cap-list-item"
											tabIndex={0}
											onKeyDownCapture={(ev: any) => {
												onPressEnterArea(ev, area);
											}}
											onClick={() => selectAreaCAP(area)}
										>
											{`${area.Comune} ${area.CAPMultipli ? `cap ${area.CAP} ` : ``}(${area.Provincia})`}
										</List.Item>
									)}
									footer={
										<>
											<div className="title item ">
												<span>{t("areaCAP.capNonTrovato.titolo")}</span>
											</div>
											<div className="text item">
												<CustomTranslation t={t} i18Key={"areaCAP.capNonTrovato.sottotitolo"} type="phone"></CustomTranslation>
											</div>
										</>
									}
								/>
							</ConfigProvider>
						</div>
					</CustomShelf>

					<div className="button-box item">
						<CustomButton text={t("backButton")} OnClick={() => MoveStep("prev")} buttonType={CustomButtonType.negative} />
						<CustomButton
							text={t("prestazione.button")}
							htmlType="submit"
							buttonType={CustomButtonType.positive}
							enabled={areaCAPSelected !== undefined}
						/>
					</div>
				</Form>
			</>
		</div>
	);
};

export default Enhanced(AreaCAP, { componentNamespace: "AreaCAP" });
